import React, { Component } from 'react';
import Radium from 'radium';
import { NavLink } from 'react-router-dom';
import helper from '../services/helper';

class Nav extends Component {

    handleClick(event) {
        this.props.onClick(event.target);
    }

    render() {
        let title = helper.getCurrentPageName();
        const style = {
            nav: {
                position: 'fixed',
                bottom: -1,
                left: 0,
                right: 0,
                background: '#F8FAFC',
                borderTop: '1px solid #DDDDDD'
            },
            navLink: {
                display: 'block',
                float: 'left',
                position: 'relative',
                cursor: 'pointer',
                width: 70,
                padding: 20,
                fontSize: 20,
                borderTop: '1px solid #DDD',
                top: -1,
                textAlign: 'center',
                boxSizing: 'border-box',
                color: '#CCC',
                textDecoration: 'none'
            },
            navLinkActive: {
                color: '#38B08C',
                borderTopColor: '#38B08C'
            },
            buttonInactive: {
                cursor: 'default',
                color: '#DDD',
            },
            incomeHeader: {
                pointerEvents: 'none',
                color: 'green'
            },
            expenseHeader: {
                pointerEvents: 'none',
                color: 'orange'
            },
            main: {
                backgroundColor: '#FFF',
                width: 280,
                height: 60,
                float: 'left',
                marginRight: 10,
                borderLeft: '1px solid #DDD',
                borderRight: '1px solid #DDD'
            },
            title: {
                float: 'left',
                position: 'relative',
                cursor: 'pointer',
                width: 220,
                padding: '20px 30px',
                fontSize: 16,
                borderTop: '1px solid #DDD',
                color: '#999',
                top: -1,
                boxSizing: 'border-box',
                textDecoration: 'none'
            }
        };
        return (
            <nav style={style.nav}>
                <div style={style.title}>{title}</div>
                <div style={style.main} className="cf">
                    <NavLink style={style.navLink} activeStyle={style.navLinkActive} to={`/income/single`} >
                        <i className="fa fa-arrow-circle-down fa-fw"></i>
                    </NavLink>
                    <NavLink style={style.navLink} activeStyle={style.navLinkActive} to={`/income/month`} >
                        <i className="fa fa-building-o fa-fw"></i>
                    </NavLink>
                    <div style={style.divider}></div>
                    <NavLink style={style.navLink} activeStyle={style.navLinkActive} to={`/expenses/single`} >
                        <i className="fa fa-arrow-circle-up fa-fw"></i>
                    </NavLink>
                    <NavLink style={style.navLink} activeStyle={style.navLinkActive} to={`/expenses/month`} >
                        <i className="fa fa-credit-card fa-fw"></i>
                    </NavLink>
                </div>
                <div data-action="add" style={style.navLink} onClick={this.handleClick.bind(this)}><i className="fa fa-plus"></i></div>
                <div data-action="delete" style={[style.navLink, this.props.isCellSelected ? null : style.buttonInactive]} onClick={this.handleClick.bind(this)}><i className="fa fa-trash-o"></i></div>
                <a style={style.navLink} href="https://twitter.com/intent/tweet?text=Loving%20Moneylist%20to%20simplify%20my%20finances%21%20%F0%9F%92%B8&url=https%3A%2F%2Fmoneylist.co" target="_blank" rel="noopener noreferrer"><i className="fa fa-twitter"></i></a>
                <div data-action="logout" style={style.navLink} onClick={this.handleClick.bind(this)}><i className="fa fa-sign-out"></i></div>
            </nav>
        );
    }
}

export default Radium(Nav);


// WEBPACK FOOTER //
// ./src/components/Nav.js